import React, { useState, useEffect } from 'react';
import './Footer.css';
// import "../../../src/App.css";
import { BiCricketBall, BiGift, BiHome } from "react-icons/bi";
import { FaRegUser } from "react-icons/fa";
import { MdOutlineLibraryBooks } from "react-icons/md";
import { Offcanvas } from 'react-bootstrap';
import AccountStatus from '../AccountStatus/AccountStatus';
import { useNavigate } from 'react-router-dom';
import LoginPopup from '../LoginPopup/LoginPopup';

const Footer = () => {
  // const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showCricketList, setShowCricketList] = useState(false);
  const [showProfitAndLoss, setShowProfitAndLoss] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showReferAndEarn, setshowReferAndEarn] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const navigate = useNavigate();

  const handleProfile = () => {
    setShowProfile(true);
    navigate("/profile");
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // const handleClose = () => {
  //   setShowOffcanvas(false);
  // };

  const handleClick = () => {
    navigate('/');
  };

  const handleCricketBallClick = () => {
    setShowLoginPopup(true); // Show the login popup
  };

  const handleLoginPopupClose = () => {
    setShowLoginPopup(false); // Hide the login popup
  };

  const handleCricketList = () => {
    setShowCricketList(true);
    navigate('/cricketlist');
  }
  const handleProfitAndLoss = () => {
    setShowProfitAndLoss(true);
    navigate('/profitandloss')
  }

  const handleReferAndEarn = () => {
    setshowReferAndEarn(true);
    navigate('/referandearn')
  }

  // if (!isMobile) return null; // Hide footer on desktop

  return (
    <>
      {/* <nav className="navbar-footer navbar-expand-lg">
        <div className="container-fluid">
          <div className='icons'>
            Trigger login popup on click
            <button className='footer-button' onClick={handleCricketList}>
              <BiCricketBall size={20} color="white" style={{ marginRight: 0 }} />
              <p>Sports</p>
            </button>
            
            <button className='footer-button' onClick={handleReferAndEarn} >
              <BiGift size={20} color="white" style={{ marginRight: 0 }} />
              <p>Refer & Earn</p>
            </button>
            <button className='footer-button' onClick={handleClick}>
              <BiHome size={20} color="white" style={{ marginRight: 0 }} />
              <p>Home</p>
            </button>
            <button className='footer-button' onClick={handleProfitAndLoss}>
              <MdOutlineLibraryBooks size={20} color="white" style={{ marginRight: 0 }} />
              <p>Profit & Loss</p>
            </button>
            <button className='footer-button' onClick={handleProfile} style={{ cursor: 'pointer' }}>
              <FaRegUser size={15} color="white" style={{ marginRight: 0 }} />
              <p>Profile</p>
            </button>
          </div>
        </div>
      </nav> */}

      {/* <nav className="navbar-footer">
        <div className="footer-icons">
          <button className="footer-button" onClick={handleCricketList}>
            <BiCricketBall size={20} color="white" />
            <p>Sports</p>
          </button>
          <button className="footer-button" onClick={handleReferAndEarn}>
            <BiGift size={20} color="white" />
            <p>Refer & Earn</p>
          </button>
          <div className="footer-home-wrapper">
            <div className="footer-home-button" onClick={handleClick}>
              <BiHome size={20} color="white" />
            </div>
          </div>
          <button className="footer-button" onClick={handleProfitAndLoss} style={{ marginLeft: '12%' }}>
            <MdOutlineLibraryBooks size={20} color="white" />
            <p>Profit & Loss</p>
          </button>
          <button className="footer-button" onClick={handleProfile}>
            <FaRegUser size={15} color="white" />
            <p>Profile</p>
          </button>
        </div>
      </nav> */}

      {/* Direct Login Form Popup */}
      {/* {showLoginPopup && <LoginPopup onClose={handleLoginPopupClose} />} */}

      {/* Fullscreen Offcanvas for Account Status */}
      {/* <Offcanvas show={showOffcanvas} onHide={handleClose} placement="end" className="offcanvas-fullscreen">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Account Status</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <AccountStatus handleClose={handleClose} />
        </Offcanvas.Body>
      </Offcanvas> */}

      {isMobile ? (
          <footer
            id="main-footer"
            className="pb-12 px-3 md:px-0 app-bg w-full md:pr-0 mb:pb-0 md:pl-0 font-lato"
          >
            <div id="homeFooterMobile" className="w-full bg-bg_color_primary rounded-xl">
              {/* <div className="border-b-[0.5px] border-border_color_primary1 py-4">
                <h3 className="hidden md:block text-text_color_primary1 font-normal text-start text-lg md:text-xl font-bold w-full">
                  Connect with us
                </h3>
                <div className="w-full flex justify-center items-center md:items-start md:justify-start gap-2 lg:gap-2.5">
                  <div className="flex items-center justify-center overflow-hidden rounded-md">
                    <a
                      title="https://wa.link/247betfair"
                      href="https://wa.link/247betfair"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center rounded-md bg-bg_color_secondary size-[45px] md:size-[50px] hover:scale-[110%] transition-all duration-300 hover:shadow-lg hover:opacity-90"
                    >
                      WhatsApp SVG
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" className="w-6 h-6 md:w-[28px] md:h-[28px]">
                        <g clipPath="url(#clip0_140_22030)">
                          <path
                            d="M12.003 0H11.997C5.3805 0 0 5.382 0 12C0 14.625 0.846 17.058 2.2845 19.0335L0.789 23.4915L5.4015 22.017C7.299 23.274 9.5625 24 12.003 24C18.6195 24 24 18.6165 24 12C24 5.3835 18.6195 0 12.003 0ZM18.9855 16.9455C18.696 17.763 17.547 18.441 16.6305 18.639C16.0035 18.7725 15.1845 18.879 12.4275 17.736C8.901 16.275 6.63 12.6915 6.453 12.459C6.2835 12.2265 5.028 10.5615 5.028 8.8395C5.028 7.1175 5.9025 6.279 6.255 5.919C6.5445 5.6235 7.023 5.4885 7.482 5.4885C7.6305 5.4885 7.764 5.496 7.884 5.502C8.2365 5.517 8.4135 5.538 8.646 6.0945C8.9355 6.792 9.6405 8.514 9.7245 8.691C9.81 8.868 9.8955 9.108 9.7755 9.3405C9.663 9.5805 9.564 9.687 9.387 9.891C9.21 10.095 9.042 10.251 8.865 10.47C8.703 10.6605 8.52 10.8645 8.724 11.217C8.928 11.562 9.633 12.7125 10.671 13.6365C12.0105 14.829 13.0965 15.21 13.485 15.372C13.7745 15.492 14.1195 15.4635 14.331 15.2385C14.5995 14.949 14.931 14.469 15.2685 13.9965C15.5085 13.6575 15.8115 13.6155 16.1295 13.7355C16.4535 13.848 18.168 14.6955 18.5205 14.871C18.873 15.048 19.1055 15.132 19.191 15.2805C19.275 15.429 19.275 16.1265 18.9855 16.9455Z"
                            fill="url(#paint0_linear_140_22030)"
                          ></path>
                        </g>
                        <defs>
                          <linearGradient id="paint0_linear_140_22030" x1="-2.24"
                            y1="-7.70251e-08" x2="28.5351" y2="2.61163"
                            gradientUnits="userSpaceOnUse">
                            <stop stopColor="var(--icon-color-brand-secondary)"></stop>
                            <stop offset="1" stopColor="var(--icon-color-brand-tertiary)"></stop>
                          </linearGradient>
                          <clipPath id="clip0_140_22030">
                            <rect width="24" height="24" fill="white"></rect>
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </div>
                </div>
              </div> */}
              <div className="border-b-[0.5px] border-border_color_primary1 py-4 w-full grid px-3 grid-cols-2 xxs:grid-cols-3 sm:grid-cols-5 gap-4 place-items-center justify-center">
                <div className="w-full max-w-[150px] aspect-[4/1] relative">
                  <img src="/Images/upiIcon.svg" alt="Upi"
                    className="absolute inset-0 h-full w-full invert" title="Upi" loading="lazy" />
                </div>
                <div className="w-full max-w-[150px] aspect-[4/1] relative">
                  <img src="/Images/bankTransfer.svg" alt="Bank Transfer"
                    className="absolute inset-0 h-full w-full invert" title="Bank Transfer" loading="lazy" />
                </div>
                <div className="w-full max-w-[150px] aspect-[4/1] relative">
                  <img src="/Images/BeGambleAware.svg" alt="BeGamble Aware"
                    className="absolute inset-0 h-full w-full invert" title="BeGamble Aware" loading="lazy" />
                </div>
                <div className="w-full max-w-[150px] aspect-[4/1] relative">
                  <img src="/Images/cograE.svg" alt="Ecogra"
                    className="absolute inset-0 h-full w-full invert" title="Ecogra" loading="lazy" />
                </div>
                <div className="w-full max-w-[150px] aspect-[4/1] relative">
                  <img src="/Images/gamblingCommission.svg" alt="Gambling Commission"
                    className="absolute inset-0 h-full w-full invert" title="Gambling Commission" loading="lazy" />
                </div>
              </div>
              <div className="flex py-4 items-center justify-center border-b-[0.5px] border-border_color_primary1">
                <img src="/Images/gaming-1.49592c7f.png" alt="Gaming - 247betfair"
                  className="w-[100px] h-auto sm:w-[150px] sm:h-auto fill-inherit"
                  title="Gaming - 247betfair" loading="lazy" />
              </div>
              <div className="text-center text-sm py-3 text-text_color_tertiary1">
                © 2025 247betfair. All rights reserved.
              </div>
            </div>
          </footer>
        ) : (
        <footer id="main-footer"
            class="pb-12 px-3 md:px-0 pt-1 app-bg w-full md:pr-0 mb:pb-0 md:pl-0 font-lato mt-4">
            <div id="homeFooterDesktop" class="w-full  flex flex-col gap-y-4 bg-bg_color_primary p-6 ">
                {/* <div class="grid w-full grid-cols-12 lg:grid-cols-9">
                    <div class="col-span-2 flex flex-col gap-y-2">
                        <h3
                            class="hidden md:block text-text_color_primary1 font-normal text-start text-lg md:text-xl font-bold  w-full">Connect
                            with us</h3>
                        <div
                            class="w-full flex justify-center items-center md:items-start md:justify-start gap-2 lg:gap-2.5">
                            <div class="flex items-center justify-center overflow-hidden rounded-md">
                                <a title="https://wa.link/247betfair" href="https://wa.link/247betfair"
                                    target="_blank"
                                    class="flex  items-center justify-center rounded-md bg-bg_color_secondary size-[45px] md:size-[50px] hover:scale-[110%] transition-all duration-300 hover:shadow-lg hover:opacity-90">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none"
                                        class="w-6 h-6 md:w-[28px] md:h-[28px]">
                                        <g clip-path="url(#clip0_140_22030)">
                                            <path
                                                d="M12.003 0H11.997C5.3805 0 0 5.382 0 12C0 14.625 0.846 17.058 2.2845 19.0335L0.789 23.4915L5.4015 22.017C7.299 23.274 9.5625 24 12.003 24C18.6195 24 24 18.6165 24 12C24 5.3835 18.6195 0 12.003 0ZM18.9855 16.9455C18.696 17.763 17.547 18.441 16.6305 18.639C16.0035 18.7725 15.1845 18.879 12.4275 17.736C8.901 16.275 6.63 12.6915 6.453 12.459C6.2835 12.2265 5.028 10.5615 5.028 8.8395C5.028 7.1175 5.9025 6.279 6.255 5.919C6.5445 5.6235 7.023 5.4885 7.482 5.4885C7.6305 5.4885 7.764 5.496 7.884 5.502C8.2365 5.517 8.4135 5.538 8.646 6.0945C8.9355 6.792 9.6405 8.514 9.7245 8.691C9.81 8.868 9.8955 9.108 9.7755 9.3405C9.663 9.5805 9.564 9.687 9.387 9.891C9.21 10.095 9.042 10.251 8.865 10.47C8.703 10.6605 8.52 10.8645 8.724 11.217C8.928 11.562 9.633 12.7125 10.671 13.6365C12.0105 14.829 13.0965 15.21 13.485 15.372C13.7745 15.492 14.1195 15.4635 14.331 15.2385C14.5995 14.949 14.931 14.469 15.2685 13.9965C15.5085 13.6575 15.8115 13.6155 16.1295 13.7355C16.4535 13.848 18.168 14.6955 18.5205 14.871C18.873 15.048 19.1055 15.132 19.191 15.2805C19.275 15.429 19.275 16.1265 18.9855 16.9455Z"
                                                fill="url(#paint0_linear_140_22030)"></path>
                                        </g>
                                        <defs>
                                            <linearGradient id="paint0_linear_140_22030" x1="-2.24"
                                                y1="-7.70251e-08" x2="28.5351" y2="2.61163"
                                                gradientUnits="userSpaceOnUse">
                                                <stop stop-color="var(--icon-color-brand-secondary)"></stop>
                                                <stop offset="1"
                                                    stop-color="var(--icon-color-brand-tertiary)"></stop>
                                            </linearGradient>
                                            <clipPath id="clip0_140_22030">
                                                <rect width="24" height="24" fill="white"></rect>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* <div class="flex items-center justify-center gap-x-2 py-4"></div> */}
                <div
                    class="w-full grid py-4 h-max px-3 grid-cols-2 xxs:grid-cols-3 sm:grid-cols-5 gap-4 place-items-center justify-center">
                    <div class="w-full max-w-[150px] aspect-[3/1] relative">
                        <img src="/Images/upiIcon.svg" alt="Upi"
                            class="absolute inset-0 h-full w-full invert" title="Upi" loading="lazy" />
                    </div>
                    <div class="w-full max-w-[150px] aspect-[3/1] relative">
                        <img src="/Images/bankTransfer.svg" alt="Bank Transfer"
                            class="absolute inset-0 h-full w-full invert" title="Bank Transfer"
                            loading="lazy" />
                    </div>
                    <div class="w-full max-w-[150px] aspect-[3/1] relative">
                        <img src="/Images/BeGambleAware.svg" alt="BeGamble Aware"
                            class="absolute inset-0 h-full w-full invert" title="BeGamble Aware"
                            loading="lazy" />
                    </div>
                    <div class="w-full max-w-[150px] aspect-[3/1] relative">
                        <img src="/Images/cograE.svg" alt="Ecogra"
                            class="absolute inset-0 h-full w-full invert" title="Ecogra" loading="lazy" />
                    </div>
                    <div class="w-full max-w-[150px] aspect-[3/1] relative">
                        <img src="/Images/gamblingCommission.svg" alt="Gambling Commission"
                            class="absolute inset-0 h-full w-full invert" title="Gambling Commission"
                            loading="lazy" />
                    </div>
                </div>
                <div class="flex py-4 items-center justify-center">
                    <img src="/Images/gaming-1.49592c7f.png" alt="Gaming - 247betfair"
                        class="w-[100px]  h-auto sm:w-[150px] sm:h-auto  fill-inherit"
                        title="Gaming - 247betfair" loading="lazy" />
                </div>
                <div class="text-center text-sm py-3 text-text_color_tertiary1">© 2025 247betfair. All
                    rights reserved.</div>
            </div>
        </footer>
      )}


    </>
  );
};

export default Footer;
